import { createContext } from "react";

import { ResolvedColumn } from "./ResolvedColumn";

/** The table layout context value. */
export interface TableLayoutContextValue {
  /** The left-locked table columns. */
  readonly leftColumns: ReadonlyArray<ResolvedColumn>;

  /** The middle table columns. */
  readonly middleColumns: ReadonlyArray<ResolvedColumn>;

  /** The right-locked table columns. */
  readonly rightColumns: ReadonlyArray<ResolvedColumn>;

  /** The left column offsets. */
  readonly leftOffsets: ReadonlyArray<number>;

  /** The right column offsets. */
  readonly rightOffsets: ReadonlyArray<number>;

  /** The width of the table viewport. */
  readonly viewportWidth: number;
}

/** The table layout context. */
export const TableLayoutContext = createContext<TableLayoutContextValue>({
  leftColumns: [],
  middleColumns: [],
  rightColumns: [],
  leftOffsets: [],
  rightOffsets: [],
  viewportWidth: 0,
});
